<template>
    <div>
        <compra-direta-ferramenta-de-busca v-model="filtrosBuscaAvancada"
                                           :situacoesPossiveis="situacoesPossiveisFornecedor"
                                           :placeholderPesquisa="placeholderPesquisa"
                                           :filtros="filtrosInterno"
                                           @eventoBuscaSimples="tratarEventoBuscaSimples"
                                           @eventoRemoverFiltro="tratarEventoRemoverFiltro"
                                           @eventoBuscaAvancada="processarEventoBuscarAvancada"
                                           @updateSituacoes="(situacoes) => filtrosBuscaAvancada.situacoes = situacoes">
        </compra-direta-ferramenta-de-busca>

        <listagem-compra-direta-situacao-unica :itens="itens"
                                               :paginas="paginas"
                                               :total-itens="totalItens"
                                               :paginacao="$store.state.fornecedor.resultadoBuscaComprasDiretasEncerradas.paginacao"
                                               :textoVazio="'Não há compras diretas encerradas'"
                                               @acessarPncp="acessarPncp"
                                               @paginar="tratarEventoPaginar"
                                               @acessar="tratarEventoAcessar">
        </listagem-compra-direta-situacao-unica>
    </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import ListagemCompraDiretaSituacaoUnica from '@/views/pages/commons/listagem-compra-direta-situacao-unica/ListagemCompraDiretaSituacaoUnica'
import CompraDiretaFerramentaDeBusca from '@/views/pages/commons/busca-avancada/CompraDiretaFerramentaDeBusca'

export default {
    name: 'ComprasDiretasEncerradasDoFornecedor',
    components: {
        CompraDiretaFerramentaDeBusca,
        ListagemCompraDiretaSituacaoUnica
    },
    data() {
        return {
            paginas: 0,
            totalItens: 0,
            itens: [],
            filtrosInterno: this.getFiltrosCompraDiretaEncerradas(),
            filtrosBuscaAvancada: this.getFiltrosBuscaAvancadaFornecedor(),
            ehBuscaAvancada: false
        }
    },
    computed: {
        placeholderPesquisa() {
            const texto = this.$t('main.commons_listagem_situacao.text').toLowerCase()
            return `Busque por: nº processo, nº consulta, objeto ou ${texto}`
        },
        situacoesPossiveisFornecedor(){
            const situacoesPossiveis = { ...this.situacoesCompraDireta }

            delete situacoesPossiveis['EM_ELABORACAO']

            return situacoesPossiveis
        }
    },
    methods: {
        async buscar() {
            this.$store.commit(mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_COMPRA_DIRETA_ENCERRADA, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_COMPRAS_DIRETAS_ENCERRADAS)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.resetFiltroBuscaAvancadaFornecedor()
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.objeto.value = valor
                this.filtrosInterno.conteudo = valor
                this.buscar()
            }
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.resetFiltroBuscaAvancadaFornecedor()
            this.filtrosBuscaAvancada = this.getFiltrosBuscaAvancadaFornecedor()
            this.buscar()
        },
        tratarEventoPaginar(paginacao) {
            if(this.ehBuscaAvancada){
                this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, paginacao)
                this.processarEventoBuscarAvancada()
            }
            else {
                this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_ENCERRADA, paginacao)
                this.buscar()
            }
        },
        tratarEventoAcessar(id) {
            this.$store.commit(mutationTypes.SET_ROTA_ORIGEM, 'ComprasDiretasEncerradasDoFornecedor')
            this.$router.push({name: 'DetalhesCompraDireta', params: {id}})
        },
        getFiltrosCompraDiretaEncerradas() {
            return _.cloneDeep(this.$store.state.fornecedor.resultadoBuscaComprasDiretasEncerradas.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        async acessarPncp({cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp}) {
            await this.$store.dispatch(actionTypes.EXIBIR_NO_PNCP, {cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp})
        },
        getFiltrosBuscaAvancadaFornecedor() {
            return _.cloneDeep(this.$store.state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor.filtros)
        },
        resetFiltroBuscaAvancadaFornecedor(){
            this.ehBuscaAvancada = false
            this.$store.state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor.reset()

            /**
             * TODO Refatorar o funcionamento da busca avançada para se usar o esquema da busca simples
             *  e depois remove essas linhas abaixo, e também o atributo ehBuscaAvancada
             */

            const paginacaoInicial = {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            }
            this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_ENCERRADA, paginacaoInicial)
            this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, paginacaoInicial)
        },
        async processarEventoBuscarAvancada() {
            this.$store.commit(mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, this.filtrosBuscaAvancada)
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.ehBuscaAvancada = true
        },
    }
}
</script>

<style scoped>

</style>
